<template lang="html">
  <h1>404 Try Harder!</h1>
</template>

<script>


export default {
  name: 'Logout',
}
</script>
